import { currentCalendarDate } from "../../shared/calendar-date";
import { invoiceOutstandingMinor } from "../../shared/invoice-settlement";
import type { InvoiceDraftRecord } from "./invoiceApi";

export interface HomeDocument {
  kind: "invoice" | "estimate";
  record: InvoiceDraftRecord;
}

// The existing list endpoints return the complete owned collection, without pagination.
// This is a Home presentation projection, using the canonical settlement calculation.
export function homeSummary(invoices: InvoiceDraftRecord[], estimates: InvoiceDraftRecord[], today = currentCalendarDate()) {
  const documents: HomeDocument[] = [
    ...invoices.map(record => ({ kind: "invoice" as const, record })),
    ...estimates.map(record => ({ kind: "estimate" as const, record })),
  ];
  const active = documents.filter(({ record }) => !record.archivedAt);
  const outstanding = invoices.filter(record => !record.archivedAt && record.documentState === "issued" && invoiceOutstandingMinor(record) > 0)
    .sort((a, b) => a.dueDate.localeCompare(b.dueDate) || a.id.localeCompare(b.id));
  const overdue = outstanding.filter(record => record.dueDate < today);
  const outstandingMinor = outstanding.reduce((sum, record) => sum + invoiceOutstandingMinor(record), 0);
  const overdueMinor = overdue.reduce((sum, record) => sum + invoiceOutstandingMinor(record), 0);
  const drafts = active.filter(({ record }) => record.documentState === "draft" && !record.convertedInvoiceId)
    .sort((a, b) => b.record.updatedAt.localeCompare(a.record.updatedAt) || a.record.id.localeCompare(b.record.id));
  return {
    hasDocuments: documents.length > 0,
    outstandingMinor, overdueMinor, otherOutstandingMinor: outstandingMinor - overdueMinor,
    outstandingCount: outstanding.length, overdueCount: overdue.length,
    invoiceDraftCount: drafts.filter(({ kind }) => kind === "invoice").length,
    estimateDraftCount: drafts.filter(({ kind }) => kind === "estimate").length,
    draftCount: drafts.length,
  };
}
